import { ComponentRef, Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { LoadingComponent } from "@mipro/components/loading.component";

@Directive({
    // This was renamed because of the conflict it was causing with any property called loading when using it on a binding syntax like:  [loading]="true" as it will try to load the "loading" directive
    selector: "[miproLoading]"
})
export class LoadingDirective {
    private loadingRef: ComponentRef<LoadingComponent>;
    private _diameterPx = "50px";
    private _inline = false;

    @Input() set miproLoading(loadingExpr: boolean) {
        this.clear();
        if (loadingExpr) {
            this.loadingRef = this.containerRef.createComponent(LoadingComponent);
            this.setDiameter();
            this.setInline();
        } else {
            this.containerRef.createEmbeddedView(this.tmpl);
        }
    }

    @Input() set miproLoadingDiameterPx(dpx: string) {
        this._diameterPx = dpx;
        this.setDiameter();
    }

    @Input() set miproLoadingInline(inline: boolean) {
        this._inline = inline;
        this.setInline();
    }

    constructor(private tmpl: TemplateRef<any>, private containerRef: ViewContainerRef) {}

    private clear() {
        this.containerRef.clear();
        if (this.loadingRef) {
            this.loadingRef = null;
        }
    }

    private setDiameter() {
        if (this.loadingRef) {
            this.loadingRef.instance.diameterPx = this._diameterPx;
        }
    }

    private setInline() {
        if (this.loadingRef) {
            this.loadingRef.instance.inline = this._inline;
        }
    }
}
